import React, { useState, useEffect } from 'react';
import { Card, Col, Row, Menu, Dropdown, Button, Divider, Space, Tabs, Spin } from "antd";
import { Link } from "react-router-dom";
import { Wallet2, Printer, Box, Cards, Call, ShoppingCart } from 'iconsax-react';
import { useSelector } from "react-redux";

const { TabPane } = Tabs;

import MyEquipmentTable from "./MyEquipmentTable";
import DeliveriesTable from "./DeliveriesTable";
import InvoicesTable from "./InvoicesTable";
import OrdersTable from "./OrdersTable";
import DashboardImage from "../../assets/images/dashboard-image.png";
import { getDashboardTileData, getCustomerStatement } from "../../redux/dashboard/dashboardActions";
import { formatCurrency, formatDate } from "../../utils/utils";
import StatementTable from './StatementReport';

export default function Home() {
  const [tileData, seTileData] = useState(null);
  const [spinStatus, setSpinStatus] = useState(false);
  const [permissionState, setPermissionState] = useState([]);
  const [isAddButtonEnabled, setIsAddButtonEnabled] = useState(false);
  const [isViewButtonEnabled, setIsViewButtonEnabled] = useState(false);
  const [isExportButtonEnabled, setIsExportButtonEnabled] = useState(false);
  const [isStatementVisible, setIsStatementVisible] = useState(false);

  const { authorizedPages, pageRoute } = useSelector((state) => state.settings);

  useEffect(() => {
    const matchedPageObject = authorizedPages?.find((item) => {
      const normalizedScreen = item.screen.replace(/\/$/, '').toLowerCase();
      const isEndPointMatched = normalizedScreen.startsWith(pageRoute);

      return isEndPointMatched;
    });

    if (matchedPageObject) {
      const formattedPermission = matchedPageObject.permission ? matchedPageObject.permission.split(',').map(eachPermission => eachPermission.trim()) : [];

      setPermissionState(formattedPermission);
    }
    else {
      setPermissionState([]);
    };
  }, [authorizedPages, pageRoute]);

  useEffect(() => {
    const hasAddPermission = ['add', 'full'].some(requiredPermission => permissionState?.includes(requiredPermission));
    const hasUpdatePermission = ['update', 'full'].some(requiredPermission => permissionState?.includes(requiredPermission));
    const hasExportPermission = ['export', 'full'].some(requiredPermission => permissionState?.includes(requiredPermission));

    setIsAddButtonEnabled(hasAddPermission);
    setIsViewButtonEnabled(hasUpdatePermission);
    setIsExportButtonEnabled(hasExportPermission);
  }, [permissionState]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setSpinStatus(true);
        const tileResult = await getDashboardTileData({ cardCode: localStorage.getItem('cardCode') });
        setSpinStatus(false);

        if (tileResult) {
          seTileData(tileResult);
        }
      } catch (error) {
      }
    };

    fetchData();
  }, []);

  const menu = (
    <Menu>
      <Menu.Item key="1">
        <a href="/create-order-by-equipment">Create Order By Equipment</a>
      </Menu.Item>
      <Menu.Item key="2">
        <a href="/create-order-by-item">Create Order By Item</a>
      </Menu.Item>
    </Menu>
  );

  const handleStatementCancel = () => {
    setIsStatementVisible(false);
  };

  const handleStatementOpen = () => {
    setIsStatementVisible(true);
  };

  return (
    <>
      <Spin spinning={spinStatus} size="large">
        <Row gutter={[18, 18]}>
          <Col span={24}>
            <Row gutter={[18, 18]}>
              <Col span={24}>
                <Row gutter={[18, 18]} align="middle" justify='space-between'>
                  <Col>
                    <h1 class="h5 hp-mb-0">🚀 Dashboard</h1>
                  </Col>
                  <Col>
                    <Space>
                      <Link to={isAddButtonEnabled ? "/payments" : "#"}>
                        <Button
                          type="primary"
                          ghost
                          size='small'
                          disabled={!isAddButtonEnabled}
                        >
                          <Cards size={18} className='hp-mr-8' />Make Payment
                        </Button>
                      </Link>

                      <Link to={isAddButtonEnabled ? "/place-order" : "#"}>
                        <Button
                          type="primary"
                          size='small'
                          disabled={!isAddButtonEnabled}
                        >
                          <ShoppingCart size={18} className='hp-mr-8' />Place Order
                        </Button>
                      </Link>
                    </Space>
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <Divider className='hp-my-0' />
              </Col>
              <Col span={24} sm={24} md={24}>
                <Row gutter={[18, 18]} align='center' justify='start'>
                  <Col span={24} sm={24} md={6} lg={6}>
                    <Card className="hp-border-color-primary-2 hp-bg-color-primary-1 hp-cursor-pointer card-hover" onClick={handleStatementOpen}>
                      <Row align='middle' justify='space-between'>
                        <Col>
                          <p className="hp-p1-body hp-text-color-black-0">Account Balance</p>
                          <h4 className="hp-mb-8 hp-text-color-black-0">{formatCurrency(tileData?.acctBalance)}</h4>
                        </Col>
                        <Col>
                          <Wallet2 size={28} color='#fff' />
                        </Col>
                      </Row>
                    </Card>
                  </Col>
                  <Col span={24} sm={24} md={6} lg={6}>
                    <Card className="hp-border-color-primary-2 hp-bg-color-primary-1">
                      <Row align='middle' justify='space-between'>
                        <Col>
                          <p className="hp-p1-body hp-text-color-black-0">Total Equipment</p>
                          <h4 className="hp-mb-8 hp-text-color-black-0">{tileData?.totalEquipment || "-"}</h4>
                        </Col>
                        <Col>
                          <Printer size={28} color='#fff' />
                        </Col>
                      </Row>
                    </Card>
                  </Col>
                  <Col span={24} sm={24} md={6} lg={6}>
                    <Card className="hp-border-color-primary-2 hp-bg-color-primary-1">
                      <Row align='middle' justify='space-between'>
                        <Col>
                          <p className="hp-p1-body hp-text-color-black-0">Total Orders</p>
                          <h4 className="hp-mb-8 hp-text-color-black-0">{tileData?.totalOpenOrders || "-"}</h4>
                        </Col>
                        <Col>
                          <Box size={28} color='#fff' />
                        </Col>
                      </Row>
                    </Card>
                  </Col>
                  <Col span={24} sm={24} md={6} lg={6}>
                    <div className='hp-w-100 hp-text-center'>
                      <img src={DashboardImage} alt="Image" width={222} />
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <Divider className='hp-my-0' />
                <Tabs defaultActiveKey="1">
                  <TabPane tab="My Equipment" key="1">
                    <MyEquipmentTable isAddButtonEnabled={isAddButtonEnabled} />
                  </TabPane>
                  <TabPane tab="Orders" key="2">
                    <OrdersTable />
                  </TabPane>
                  <TabPane tab="Deliveries" key="3">
                    <DeliveriesTable />
                  </TabPane>
                  <TabPane tab="Invoices" key="4">
                    <InvoicesTable />
                  </TabPane>
                </Tabs>
              </Col>
            </Row>
          </Col>
        </Row>
      </Spin>

      <StatementTable
        isVisible={isStatementVisible}
        onCancel={handleStatementCancel}
      />
    </>
  );
}
